import { forwardRef } from 'react'

import { IconProps } from '../Types'

export const ArrowRightThick = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M6 10.9844H17V12.9844H6V10.9844Z" fill={color} />
        <path d="M11.5796 16.2428L17.2364 10.5859L18.672 12.0215L13.0152 17.6784L11.5796 16.2428Z" fill={color} />
        <path d="M17.2361 13.4137L11.5793 7.75688L13.0149 6.32128L18.6717 11.9781L17.2361 13.4137Z" fill={color} />
      </svg>
    )
  },
)

export default ArrowRightThick
